const APIResourceType = {
  Swatch: "Swatch",
  File: "File",
  Typography: "Typography",
  PagePathnameSlice: "PagePathnameSlice",
  GlobalElement: "GlobalElement",
  LocalizedGlobalElement: "LocalizedGlobalElement",
  Table: "Table",
  Snippet: "Snippet",
  Page: "Page",
  Site: "Site"
};
export {
  APIResourceType
};
//# sourceMappingURL=types.js.map